import { Button } from '@dapp/multi-lib/sdaoui/Button';
import { Icon } from '@dapp/multi-lib/sdaoui/Icon';
import { cx } from 'class-variance-authority';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';
import { PoolSelection, ViewTypes } from 'structure/multi-asset-staking/types';

interface IStakingPoolsActionsProps {
  view: string;
  handleView: (value: ViewTypes) => void;
  handlePoolSelection: (value: PoolSelection) => void;
  pool: PoolSelection;
}

export const StakingPoolsActions = ({
  handleView,
  handlePoolSelection,
  view,
  pool,
}: IStakingPoolsActionsProps) => {
  const { t } = useTranslation('common');

  return (
    <>
      <div className='my-8 flex items-center justify-between'>
        <div className='flex items-center gap-2'>
          <Button
            size='small'
            className={
              pool !== PoolSelection.ALL
                ? 'border border-white bg-transparent text-white'
                : undefined
            }
            onClick={() => handlePoolSelection(PoolSelection.ALL)}
          >
            {t('ALL_POOLS')}
          </Button>
          {/* <Button
            size='small'
            className={
              pool !== PoolSelection.MYPOOLS &&
              'border border-white bg-transparent text-white'
            }
            onClick={() => handlePoolSelection(PoolSelection.MYPOOLS)}
          >
            {t('MY_POOLS')}
          </Button> */}
        </div>
        <div className='flex items-center gap-2'>
          <Icon
            icon='list_outline'
            width='24'
            height='24'
            className={twMerge(
              'cursor-pointer',
              cx(view === ViewTypes.LIST_VIEW ? 'text-blue-500' : 'text-white')
            )}
            onClick={() => handleView(ViewTypes.LIST_VIEW)}
          />
          <Icon
            icon='apps'
            width='24'
            height='24'
            className={cx(
              'cursor-pointer',
              twMerge(
                view === ViewTypes.CARD_VIEW ? 'text-blue-500' : 'text-white'
              )
            )}
            onClick={() => handleView(ViewTypes.CARD_VIEW)}
          />
        </div>
      </div>
    </>
  );
};
